import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'

const options = {
  maintainAspectRatio: false,
  plugins: {
    clip: true,
    responsive: true,
    datalabels: {
      formatter: function (value, ctx) {
        return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value] + ' %'
      },
      textAlign: 'center',
      color: 'white',
      anchor: 'center',
      clamp: true,
      display: false,
    },

    legend: {
      display: true,
      position: 'bottom',
      align: 'left',
      labels: {
        color: 'rgba(255,255,255,0.78)',
        usePointStyle: true,
        boxWidth: 10,
      },
    },
    title: {
      display: false,
      text: '',
    },
  },
}

export default function Chart1({ chartData }) {
  const [labels, setLabels] = useState([])
  const [cdata, setcdata] = useState([])
  // console.log(chartData)
  useEffect(() => {
    let labls = []
    let dd = []
    if (chartData) {
      chartData.forEach((e) => {
        labls.push(e.name)
        dd.push(e.value)
      })
      setLabels(labls)
      setcdata(dd)
    }
  }, [chartData])
  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: cdata,
        backgroundColor: ['#ef7d56', '#7cc6b2', '#5aa1d8'],
        borderColor: '#082348',
        borderWidth: 3,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  }
  return (
    <div style={{ height: 330 }}>
      <Doughnut data={data} options={options} />
    </div>
  )
}
